<template>
    <v-menu offset-y
            nudge-bottom="22"
            min-width="175"
            left
            :elevation="$vuetify.theme.dark ? 9 : 8">
        <!-- Activator -->
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs"
                 class="d-flex align-center mr-3 arabic"
                 v-on="on"
                 @click="updateActiveLocale">
                <v-img v-if="locales[0].title == 'English'"
                       :src="require(`@/assets/images/flags/en.png`)"
                       :alt="$i18n.locale"
                       height="14px"
                       width="22px"
                       class="me-2"></v-img>
                <v-img v-if="locales[0].title == 'العربية'"
                       :src="require(`@/assets/images/flags/ar.png`)"
                       :alt="$i18n.locale"
                       height="14px"
                       width="22px"
                       class="me-2"></v-img>
                <span class="text-black"
                      style="font-size: 16px;font-family: 'BentonSans'"
                      v-if="locales[0].title == 'English'">{{ locales[0].title }}</span>
                      <!-- $vuetify.breakpoint.smAndUp &&  -->

                <span class="text-black"
                      style="font-size: 16px;font-family: 'Frutiger LT Arabic'"
                      v-if="locales[0].title == 'العربية'">{{ locales[0].title }}</span>
            </div>
        </template>

        <!-- Options List -->
        <!-- <v-list>
      <v-list-item-group
        :value="$i18n.locale"
        @change="updateActiveLocale"
      >
        <v-list-item
          v-for="locale in locales"
          :key="locale.locale"
          :value="locale.locale"
        >
          <v-img
            :src="locale.img"
            height="14px"
            width="22px"
            :alt="locale.locale"
            class="me-2"
          ></v-img>
          <v-list-item-title>{{ locale.title }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list> -->
    </v-menu>
</template>

<script>
import { loadLanguageAsync } from '@/plugins/i18n'
import useAppConfig from '@core/@app-config/useAppConfig'

export default {
    setup()
    {
        const { isRtl } = useAppConfig()
        var currentLangTemp = 'العربية'
        var currentLang = 'en'

        const locales = [
            {
                title: 'العربية',
                img: require('@/assets/images/flags/en.png'),
                locale: 'en',
            },
            {
                title: 'العربية',
                img: require('@/assets/images/flags/ar.png'),
                locale: 'ar',
            },
        ]

        var lang = localStorage.getItem('language');

        if (lang)
        {
            if (lang == 'ar')
            {
                loadLanguageAsync(lang);
                currentLang = lang;
                locales[0].title = 'English';
                currentLangTemp = 'English';
                localStorage.setItem('language', 'ar');
            }
            else
            {
                loadLanguageAsync(lang);
                currentLang = lang;
                locales[0].title = 'العربية';
                currentLangTemp = 'العربية';
                localStorage.setItem('language', 'en');
            }
        }
        else
        {
            localStorage.setItem('language', 'en')
        }

        const updateActiveLocale = locale =>
        {
            if (locales[0].title == 'العربية')
            {
                isRtl.value = true
                locales[0].title = 'English';
                currentLangTemp = 'English'
                loadLanguageAsync('ar');
                localStorage.setItem('language', 'ar')
            }
            else
            {
                isRtl.value = false
                locales[0].title = 'العربية';
                currentLangTemp = 'العربية'
                loadLanguageAsync('en');
                localStorage.setItem('language', 'en')
            }
            // currentLang = store.get('accounts/language');
            // Set to RTL mode if locale is arabic
        }

        return {
            locales,
            currentLangTemp,
            currentLang,
            updateActiveLocale,
        }
    },
}
</script>
